import {createRoot} from 'react-dom/client';

import { SearchApp } from "./App";


const app = document.getElementById("app");
createRoot(app).render(<SearchApp />);